module.exports = __webpack_public_path__ + "img/main_tips_mall.dfafc06e.png";